module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN313_1387004133.0ad6fb7d.png";